import { z } from "zod";
import {
  MemoryFactEdgeMetadataSchema,
  MemoryFactNodeContentSchema,
} from "./FactNodes/MemoryFactNode";
import {
  NoteFactNodeContentSchema,
  NoteOnPersonFactEdgeMetadataSchema,
} from "./FactNodes/NoteFactNode";
import { OrganizationFactNodeContentSchema } from "./FactNodes/OrganizationFactNode";
import {
  PersonFactNodeContentSchema,
  PersonKnowsFactEdgeMetadataSchema,
  PersonWorksAtFactEdgeMetadataSchema,
} from "./FactNodes/PersonFactNode";
import { RootFactNodeContentSchema } from "./FactNodes/RootFactNode";

export const FactNodeContentSchema = z.discriminatedUnion("nodeType", [
  RootFactNodeContentSchema,
  OrganizationFactNodeContentSchema,
  MemoryFactNodeContentSchema,
  PersonFactNodeContentSchema,
  NoteFactNodeContentSchema,
]);

export const FactNodeSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  nodeType: z.string(),
  content: FactNodeContentSchema,
});

export const FactEdgeMetadataSchema = z.discriminatedUnion("edgeType", [
  MemoryFactEdgeMetadataSchema,
  PersonKnowsFactEdgeMetadataSchema,
  PersonWorksAtFactEdgeMetadataSchema,
  NoteOnPersonFactEdgeMetadataSchema,
]);

export const FactEdgeSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  edgeType: z.string(),
  metadata: FactEdgeMetadataSchema,
  sourceId: FactNodeSchema.shape.id,
  targetId: FactNodeSchema.shape.id,
});

export type FactNode = z.infer<typeof FactNodeSchema>;
export type FactNodeContent = z.infer<typeof FactNodeContentSchema>;
export type FactEdge = z.infer<typeof FactEdgeSchema>;
export type FactEdgeMetadata = z.infer<typeof FactEdgeMetadataSchema>;
